import { createRoutine } from 'redux-saga-routines';

export const triggerToast = createRoutine('TRIGGER_TOAST');
export const dismissToast = createRoutine('DISMISS_TOAST');
export const setToastError = createRoutine('SET_TOAST_ERROR');
export const setToastSuccess = createRoutine('SET_TOAST_SUCCESS');
export const setToastProcessing = createRoutine('SET_TOAST_PROCESSING');
